<template>
  <div class="safe">
    <div class="header">
    	<div class="header-layout">
    		<h1 class="logo" id="logo">
    			<a href="http://www.ddzzii.com"></a>
    		</h1>
    		<a class="logo-title"> {{ivActionType}} </a>
    		<ul class="header-nav">
    			<li class="li-first">
    				<div>您好，{{$store.state.username}}</div>
    			</li>
    			<li>
    				<a class="logout" @click="$api.user.logout()">退出</a>
    			</li>
    			<li>
    				<a href="/index">首页</a>
    			</li>
    			<li>
    				<a href="">帮助中心</a>
    			</li>
    		</ul>
    	</div>
    </div>
	<div class="content">
		<div class="maincenter">
			<div>
				<el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
					<el-step title="验证身份"></el-step>
					<el-step :title="ivActionType"></el-step>
					<el-step title="完成"></el-step>
				</el-steps>
			</div>
			<div class="maincenter-box">
				<div style="width: 80%;margin:0 auto;font-size: 14px;border-bottom: 1px solid #b9b9b9;">请完成以下操作，绑定账号<span style="color: #00B7D3;">{{$store.state.username}}</span>邮箱</div>
				<div class="form">
					<div class="form-phone">
					  <div class="form-phone-item form-item-L">电子邮箱 :</div>
					  <div class="form-phone-item form-item-M">
						<el-input v-model="mail" placeholder="请输入你的邮箱" class="form-password"></el-input>
					  </div>
					  <div class="form-phone-item form-item-R">
						  <count-down-button ref="resendCDBtn" type="primary" :time="60" @click="GetCaptcha()" style="width: 240px;"
						  	:click-start="flag">
						  	{{GetCaptchaButton}}
						  </count-down-button>
						  <!-- <el-button type="primary" style="" @click="GetCaptcha()">获取邮箱验证码</el-button> -->
					  </div>
					</div>
					<div class="form-phone">
					  <div class="form-phone-item form-item-L">验证码 :</div>
					  <div class="form-phone-item form-item-M">
						<el-input v-model="mailCode" placeholder="请输入你的邮箱验证码"  maxlength="6" class="form-password"></el-input>
					  </div>
					  <div class="form-phone-item form-item-R">
						  <div class="errmsg">{{ errmsg }}</div>
					  </div>
					</div>
					<div class="form-phone">
					  <div class="form-phone-item form-item-M submitButton">
						<el-button type="primary" @click="submitHandler()">确认</el-button>
					  </div>
					  <div class="form-phone-item form-item-R">
						<span>其他验证方式</span>
					  </div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<footer-layout></footer-layout>
  </div>
</template>

<script>
import CountDownButton from '@/components/fields/CountDownButton'
import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'BindMail',
    components: {FooterLayout,CountDownButton},
    data() {
      return {
		step: 1,
		ivActionType: '修改安全邮箱',
		GetCaptchaButton: '获取邮箱验证码',
		flag: false,
		mail: '',
		mailCode: '',
		formKey: '',
		safety: '',
		passwordVerify: [],
		errmsg: '',
        industries: [],
        errors: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
        formData: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
      }
    },
    methods: {
	  GetCaptcha() {
		if (this.mail.length < 8) {
		  this.errmsg = '请输入正确邮箱'
		} else {
			this.errmsg = ''
		  this.$api.common.sendMail(this.mail).then(res => {
			  // console.log(res)
		    if (res.code !== 0) {
				this.errmsg = res.details[0]
			} else {
				this.errmsg = ''
				this.$refs.resendCDBtn.start()
			}
		  })
		}
	  },
      submitHandler() {
		if (this.mailCode.length !== 6) {
		  this.errmsg = '请输入正确邮箱验证码'
		} else {
			this.$api.user.bindEmail(this.safety, this.mail, this.mailCode).then(res => {
				console.log(res)
			  // 1030 formKey过期 1012 验证码错误
			  if (res.code === 0) {
				  this.$router.push({path:'/finishreset'})
			  } else {
				this.errmsg = res.details[0]
			  }
			})
		}
      }
    },
    created() {
	  this.safety = this.$route.query.safety
    }
  }
</script>

<style>
.form-password .el-input__inner{
	border-radius: 0px;
	
}
</style>

<style scoped>
  .authc-steps {
    margin-top: 40px;
  	margin-bottom: 30px;
  }
  .safe .content{
  	width: 990px;
  	/* height: 1050px; */
  	margin: 0 auto;
  	font-size: 12px;
  }
  .maincenter-box .form{
  	padding: 0px 5px 20px 120px;
  }
  .maincenter-box {
  	margin: 0 auto;
  	padding: 20px 0;
  	width: 774px;
  	height: auto;
  }
  .form{
  	  margin-top: 20px;
  }
  .form-item-L {
  	  width: 70px;
  	  margin-right: 20px;
  	  text-align: right;
  	  font-size: 14px;
  }
  .form-item-M {
  	  
  }
  .form-item-M .el-button{
  	  width: 150px;
  	  /* line-height: 18px; */
  	  font-size: 12px;
  	  border-radius: 2px;
  	  margin-left: 90px;
  	  margin-right: 10px;
  }
  .form-item-R .el-button{
  	  border: 1px solid #FF751A;
  	  background-color: #FFF1E8;
  	  color: #FF751A;
  }
  .form-item-R span{
  	  color: #9B9EA0;
  	  cursor: pointer;
  }
  .form-item-R:hover span{
  	  color: #02b2f8;
  }
  .bottom-tips {
  	  margin: 0 auto;
  	  width: 774px;
  	  height: auto;
  }
  
  .form-divider{
  	  margin: 10px 0 30px 0;
  }
  
  .form-input{
  	  /* font-size: 12px; */
  	  width: 110px;
  	  margin-right: 10px;
  }
  .form-hint {
    padding: 5px 0;
    margin-bottom: 20px;
    border: 1px solid #eee;
    background: #eee;
    text-align: center;
    color: #666;
    border-radius: 2px;
  }
  
  .errmsg {
    color: red;
  	margin-left: 20px;
  }
  
  .form-phone {
  	  height: 56px;
  }
  .form-phone-item{
  	  line-height: 36px;
  	  float: left;
  }
  .form-phone-item .el-button{
  	  height: 36px;
  	  /* line-height: 18px; */
  	  font-size: 12px;
  	  border-radius: 2px;
  }
  .footer {
  	 text-align: center;
  	 width: 120px;
  	 margin: 30px auto;
  }
</style>
